import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit
} from '@angular/core';

import { RequestsServices } from '../../../../../services/requests.service';
import { StorageService } from '../../../../../services/storage.service';
import { UserService } from '../../../../../services/user.service';
import { IMultiSelectOption, IMultiSelectTexts, IMultiSelectSettings } from 'angular-2-dropdown-multiselect';
import { CostCenterService } from 'src/app/services/cost-center.service';

@Component({
  selector: 'app-colabs-filter-form',
  providers: [ RequestsServices, StorageService, UserService, CostCenterService ],
  templateUrl: './colabs-filter-form.component.html',
})

export class ColabsFilterFormComponent implements OnInit {
  @Input() public rowsCount: number;
  @Input() public isActionButtonsBlocked: boolean;
  @Output() public fetchRowsEvent = new EventEmitter<any>();

  private costCenterList: any;
  @Input() set costCenters(costCenters: any) {
    this.costCenterList = costCenters;
    this.loadCostCenters();
  }

  public filter = {
    filterRows: '',
    filterStatus: [],
    filterUnit: [],
    filterProfile: [],
  };
  public typeBusiness: string;

  public advancedFilter = {
    name: '',
    email: '',
    cpf: '',
    employeeRegistrationNumber: ''
  };

  public optionsModelStatus: string[] = this.filter.filterStatus;
  public optionsStatus: IMultiSelectOption[];

  public settingsSelectStatus: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 2,
    displayAllSelectedText: true
  };
  public selectStatusTexts: IMultiSelectTexts = {
    checkAll: 'Selecionar todos',
    uncheckAll: 'Deselecionar todos',
    checked: 'status selecionado',
    checkedPlural: 'status selecionados',
    defaultTitle: 'Selecione o Status',
    allSelected: 'Status: todos',
  };

  public optionsModelUnit: number[] = this.filter.filterUnit;
  public optionsUnit: IMultiSelectOption[];

  public settingsSelectUnit: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 2,
    displayAllSelectedText: true
  };
  public selectUnitTexts: IMultiSelectTexts = {
    checkAll: 'Selecionar todos',
    uncheckAll: 'Deselecionar todos',
    checked: 'Grupo selecionado',
    checkedPlural: 'unidades selecionadas',
    defaultTitle: 'Selecione o grupo',
    allSelected: 'Grupos: todos',
  };

  public optionsModelProfile: number[] = this.filter.filterProfile;
  public optionsProfile: IMultiSelectOption[];

  public settingsSelectProfile: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 2,
    displayAllSelectedText: true
  };
  public selectProfileTexts: IMultiSelectTexts = {
    checkAll: 'Selecionar todos',
    uncheckAll: 'Deselecionar todos',
    checked: 'perfil selecionado',
    checkedPlural: 'perfis selecionados',
    defaultTitle: 'Selecione o perfil',
    allSelected: 'Perfis: todos',
  };

  public showSimpleSearch = false;

  constructor(private costCenter: CostCenterService,
              private userService: UserService) {
  }

  public ngOnInit(): void {
    this.optionsStatus = [
        { id: 'active', name: 'Ativos' },
        { id: 'invited', name: 'Convidado' },
        { id: 'not_invited', name: 'Não convidados' },
        { id: 'hardbounce', name: 'Email com erro' },
        { id: 'blocked', name: 'Bloqueados' },
        { id: 'invite-error', name: 'Erro no convite' }
    ];

    this.optionsProfile = [
        { id: '5a1ef473694cfe4bc3935212', name: 'Master' },
        { id: '5a1ef4b2694cfe4bc3935213', name: 'Financeiro' },
        { id: '5a1ef508694cfe4bc3935215', name: 'Comunicação' },
        { id: '5a1ef50d694cfe4bc3935217', name: 'Funcionário' }
    ];

    this.typeBusiness = this.userService.getTypeAccount();
    this.initFilter();
    this.initAdvanceFilter();
    this.fetchRowsEvent.emit({params: this.filter, isSimpleSearch: this.showSimpleSearch, advancedFilter: this.advancedFilter});
  }

  public loadCostCenters(): void {
    if (this.costCenterList) {
      this.optionsUnit = this.costCenterList.map((address) => (
        {id: address.id, name: address.name}
      ));
    }
  }

  public onFilterRows(data): void {
    if (data.type === 'click') {
      this.filter = {
        filterRows: '',
        filterStatus: [],
        filterUnit: [],
        filterProfile: [],
      };
      this.advancedFilter = {
        name: '',
        email: '',
        cpf: '',
        employeeRegistrationNumber: ''
      };
    } else {
      this.filter.filterRows = data;
    }
    this.fetchRowsEvent.emit({params: this.filter, isSimpleSearch: this.showSimpleSearch, advancedFilter: this.advancedFilter});
  }

  public filterRowsByStatus(event): void {
    this.filter.filterStatus = event;
  }

  public filterRowsByUnit(event): void {
    this.filter.filterUnit = event;
  }

  public filterRowsByProfile(event): void {
    this.filter.filterProfile = event;
  }

  private initFilter(): void {
    this.filter = {
      filterRows: '',
      filterStatus: ['active', 'not_invited', 'invited', 'hardbounce', 'blocked', 'invite-error'],  // Default status selected
      filterUnit: [],
      filterProfile: [
        this.optionsProfile[3].id,
        this.optionsProfile[2].id,
        this.optionsProfile[1].id,
        this.optionsProfile[0].id
      ],
    };

    this.optionsModelUnit = this.filter.filterUnit;
    this.optionsModelProfile = this.filter.filterProfile;
    this.optionsModelStatus = this.filter.filterStatus;
  }

  private initAdvanceFilter(): void {
    this.advancedFilter = {
      name: '',
      email: '',
      cpf: '',
      employeeRegistrationNumber: ''
    };

    this.optionsModelUnit = this.filter.filterUnit;
    this.optionsModelProfile = this.filter.filterProfile;
    this.optionsModelStatus = this.filter.filterStatus;
  }

}
